import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";

const COOKIE_KEY = "cookie_consent";

const CookieBanner = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem(COOKIE_KEY);
    if (!consent) setVisible(true);
  }, []);

  const handle = (value: "accepted" | "refused") => {
    localStorage.setItem(COOKIE_KEY, value);
    setVisible(false);
  };

  return (
    <AnimatePresence>
      {visible && (
        <motion.div
          initial={{ y: 80, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: 80, opacity: 0 }}
          transition={{ duration: 0.3 }}
          className="fixed bottom-0 inset-x-0 z-[100] bg-foreground text-background border-t border-background/10"
        >
          <div className="max-w-7xl mx-auto px-4 sm:px-6 py-3 flex flex-col sm:flex-row items-center justify-between gap-3">
            <p className="font-body text-sm text-background/80 text-center sm:text-left">
              Ce site utilise des cookies pour améliorer votre expérience de navigation. En continuant, vous acceptez notre{" "}
              <Link to="/politique-de-confidentialite" className="underline hover:text-background transition-colors">
                politique de confidentialité
              </Link>.
            </p>
            <div className="flex items-center gap-2 shrink-0">
              <button
                onClick={() => handle("refused")}
                className="px-5 py-2 rounded-full border border-background/30 text-sm font-body font-semibold text-background/80 hover:text-background hover:border-background/60 transition-colors"
              >
                Refuser
              </button>
              <button
                onClick={() => handle("accepted")}
                className="px-5 py-2 rounded-full bg-accent text-accent-foreground text-sm font-body font-semibold hover:brightness-105 transition-all"
              >
                Accepter
              </button>
            </div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default CookieBanner;
